import { useCurrentUser } from '@/hooks/useCurrentUser'

const countries = {
  KE: { flag: '/kenya-flag.png', name: 'Kenya' },
  UG: { flag: '/uganda_flag.png', name: 'Uganda' },
} as const

export function CountryFlagIndicator() {
  const { data: user } = useCurrentUser()
  const code = user?.countryCode?.toUpperCase() === 'UG' ? 'UG' : 'KE'
  const country = countries[code]

  return (
    <div
      className="flex items-center gap-1.5 rounded-lg px-2 py-1.5"
      aria-label={`Signed in from ${country.name}`}
      title={country.name}
    >
      <span className="h-5 w-5 shrink-0 overflow-hidden rounded-full bg-slate-100 ring-1 ring-slate-200">
        <img className="h-full w-full object-cover" src={country.flag} alt={`${country.name} flag`} />
      </span>
      <span className="text-xs font-semibold text-slate-600">{code}</span>
    </div>
  )
}
